<template>
  <v-dialog v-model="dialog" max-width="600">
    <ValidationObserver ref="addPromoCodeForm" v-slot="{ invalid, passes }">
      <form
        rel="addPromoCodeForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7">Nový promo kód</v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="promoCode.code"
                  rules="required"
                  mode="lazy"
                  outlined
                  dense
                  label="Kód"
                  data-cy="comment"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation'
import { mapActions } from 'vuex'

export default {
  name: 'PromoCodeAddDialog',
  components: { VTextFieldWithValidation },
  data() {
    return {
      promoCode: {
        code: null,
      },
      saving: false,
      dialog: false,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('addPromoCodeDialog', function (dialog) {
      model.promoCode = {
        code: null,
      }
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      createPromoCode: 'promo/createPromoCode',
    }),
    submit() {
      this.saving = true
      this.createPromoCode({
        giftId: this.$route.params.giftId,
        promoCode: this.promoCode,
      }).finally(() => {
        this.saving = false
        this.$refs.addPromoCodeForm.reset()
        this.$emit('promoCodeAdded')
        this.close()
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
